import styled from 'styled-components'

import Icon from 'components/Shared/Icon/Index'
import TableCell from './TableCell'

export const StyledTableCell = styled(TableCell)`
  padding: 0;
`

const DragIcon = styled(Icon)`
  margin-left: 6px;
`

const TableCellDragHandle = () => {
  return (
    <StyledTableCell width='22px'>
      <DragIcon iconName='icon-drag' />
    </StyledTableCell>
  )
}

export default TableCellDragHandle
